// import 'react-app-polyfill/ie11';
// import 'react-app-polyfill/stable';
import React from "react";
import ReactDOM from "react-dom";
import App from "./components/App";
import { Provider } from "react-redux";
import {
  UserLoggedIn,
  AdminLoggedIn,
  UserLoggedOut,
  AdminLoggedOut,
} from "./redux/user/useraction";

import store from "./store";
import decode from "jwt-decode";
import registerServiceWorker from "./registerServiceWorker";
import { GlobalContextProvider } from "./context/GlobalContext";

// Check token expiration for user and admin
const checkTokenExpiration = () => {
  const userToken = localStorage.getItem("CPD_User_LoginData");
  const adminToken = localStorage.getItem("CPD_Admin_LoginData");

  // Function to check expiry
  const isTokenExpired = (tokenKey, expiryKey) => {
    const token = localStorage.getItem(tokenKey);
    const expiryTime = localStorage.getItem(expiryKey);
    const currentTime = new Date().getTime();

    console.log('current time ...', currentTime, 'expire time...', expiryTime);
    if (token && expiryTime) {
      if (currentTime > expiryTime) {
        // Token expired, remove from localStorage
        localStorage.removeItem(tokenKey);
        localStorage.removeItem(expiryKey);
        return true;
      }
    }
    return false;
  };

  // Check if User token expired
  if (userToken && isTokenExpired("CPD_User_LoginData", "CPD_User_TokenExpiry")) {
    store.dispatch(UserLoggedOut());
  } else if (userToken) {
    // If token exists but isn't expired, decode and log in user
    const loginData = decode(userToken);
    const userReserveData = localStorage.getItem("User_Data_Reserve");
    const userObject = JSON.parse(userReserveData);

    const loginUser = {
      token: userToken,
      data: {
        UserID: loginData.user.UserID,
        FullName: loginData.user.FullName,
        PrimaryEmail: loginData.user.PrimaryEmail,
        Primary_Address: loginData.user.Primary_Address,
        postal_address: loginData.user.Primary_Address,
        PEC_REG_NO: loginData.user.PEC_REG_NO,
        PEC_REG_DATE: loginData.user.PEC_REG_DATE,
        Primary_Contact_NO: userObject?.contactNumber,
        DOB: loginData.user.DOB,
        ProfileImageURL: loginData.user.profilePicture,
        gender: userObject?.gender,
        CNIC: loginData.user.CNIC,
        RoleID: loginData.user.RoleID,
        iat: loginData.iat,
        discipline: loginData.user.discipline,
        city: loginData.user.City,
        institute: loginData.user.Institute,
        province: loginData.user.province,
        engineerType: loginData.user.engineerType,
        engineerValidity: loginData.user.engineerValidity,
        yearOfGraduation: loginData.user.yearOfGraduation,
      },
    };
    store.dispatch(UserLoggedIn(loginUser));
  }

  // Check if Admin token expired
  if (adminToken && isTokenExpired("CPD_Admin_LoginData", "CPD_Admin_TokenExpiry")) {
    store.dispatch(AdminLoggedOut());
  } else if (adminToken) {
    // If token exists but isn't expired, decode and log in admin
    const loginData = decode(adminToken);
    const loginUser = {
      token: adminToken,
      data: {
        UserID: loginData.user.UserID,
        FullName: loginData.user.FullName,
        PrimaryEmail: loginData.user.PrimaryEmail,
        Primary_Address: loginData.user.Primary_Address,
        PEC_REG_NO: loginData.user.PEC_REG_NO,
        PEC_REG_DATE: loginData.user.PEC_REG_DATE,
        Primary_Contact_NO: loginData.user.Primary_Contact_NO,
        DOB: loginData.user.DOB,
        ProfileImageURL: loginData.user.profilePicture,
        gender: loginData.user.gender,
        CNIC: loginData.user.CNIC,
        RoleID: loginData.user.RoleID,
        RoleName: loginData.user.RoleName,
        iat: loginData.iat,
      },
    };
    store.dispatch(AdminLoggedIn(loginUser));
  }
};

// Add event listener for storage changes
window.addEventListener("storage", (e) => {
  if (e.key === "CPD_User_LoginData" && e.oldValue && !e.newValue) {
    store.dispatch(UserLoggedOut());
  }
  if (e.key === "CPD_Admin_LoginData" && e.oldValue && !e.newValue) {
    store.dispatch(AdminLoggedOut());
  }
});

// Call token expiration check on app load
checkTokenExpiration();

ReactDOM.render(
  <Provider store={store}>
    <GlobalContextProvider>
      <App />
    </GlobalContextProvider>
  </Provider>,
  document.getElementById("root")
);

registerServiceWorker();
